<template lang="pug">
  .alert(v-if="text")
    span.icon(v-if="type" :class="`icon--${type}`")
    p(v-html="text")
</template>

<script>
export default {
  name: 'cp-alert',
  props: {
    type: {
      type: String
    },
    text: {
      type: String,
      requerid: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .alert {
    align-items: center;
    border-radius: 8px;
    border: 1px solid rgba(189, 194, 198, 0.4);
    display: flex;
    padding: 22px 16px;

    @media screen and (min-width: 768px) {
      padding-left: 32px;
      padding-right: 56px;
    }

    .icon {
      border: 2px solid currentColor;
      border-radius: 100%;
      color: #8e8e93;
      font-family: $oscine-font-family;
      font-size: 26px;
      height: 40px;
      line-height: 38px;
      text-align: center;
      min-width: 40px;

      &--warn:after {
        content: "!";
      }
    }

    p {
      color: #595959;
      font-family: $rubik-font-family;
      font-size: 14px;
      line-height: 1.57;
      margin-left: 24px;
      width: 100%;
    }
  }
</style>
